import heMessages from '../i18n/he.json';

import type { HebrewReportMessages } from './report-shell';

export const HEBREW_REPORT_MESSAGES: HebrewReportMessages = heMessages;
